//Name not available
export const NOT_AVAILABLE = 'n/a';

export const NOT_AVAILABLE_UPPERCASE = 'N/A';

export const IDENTIFIED_STATUS_EXCEPTION = 'Identified Status Exception';

//UnitGroupType
export const UNIT_GROUP = 'G';

//UnitGroupType
export const MGC_DIRECT = 'D';

//Constants for Pagination
export const MAX_RESULT_PER_PAGE = 20;

// Phase Names
export const PHASES_LIST = [
  '1 - Define Business Scope',
  '2 - Develop Business Solution',
  '3 - Select & Negotiate Suppliers',
  '4 - Implement Strategy',
  '5 - Manage Strategy'
];
export const MAX_PHASE = 5;
export const SAM_APP_CODE = 'DMSM';
export const DM_STRATEGY_MANAGEMENT = 'Direct Material Strategy Management';

// MGC Hierarchy vs Desc
export const MGC_FILTER_HIERARCHY = 'MGC_HIERARCHY';
export const MGC_FILTER_DESC = 'MGC_DESC';
export const MGC_FILTER_CODE = 'MGC_CODE';

export const CHART_DATASETS = Object.freeze({
  GROW_TOTAL: 'grow',
  MAINTAIN_TOTAL: 'maintain',
  CONTROL_TOTAL: 'control',
  LIMITED_USE_TOTAL: 'limiteduse',
  REDUCE_TOTAL: 'reduce',
  DONOTUSE_TOTAL: 'donotuse'
});

export const LABEL_LIST_TEXT_COLORS = Object.freeze({
  [CHART_DATASETS.GROW_TOTAL]: '#367C2B',
  [CHART_DATASETS.MAINTAIN_TOTAL]: '#86B07F',
  [CHART_DATASETS.CONTROL_TOTAL]: '#FFDE00',
  [CHART_DATASETS.LIMITED_USE_TOTAL]: '#FFB000',
  [CHART_DATASETS.REDUCE_TOTAL]: '#DA6672',
  [CHART_DATASETS.DONOTUSE_TOTAL]: '#C21020'
});

export const CHART_All_DATASETS = Object.freeze({
  THIS_STRATEGY: 'this strategy',
  OTHER_STRATEGIES: 'other strategy'
});

export const SPEND_TYPES = Object.freeze({
  FORECAST: 'Forecast',
  INVOICED: 'Invoiced'
});

export const CHART_ALL_COLORS = Object.freeze({
  [CHART_All_DATASETS.THIS_STRATEGY]: '#367C2B',
  [CHART_All_DATASETS.OTHER_STRATEGIES]: '#333333'
});

export const CHART_HEIGHT = 500;

export const CHART_COLORS = Object.freeze({
  [CHART_DATASETS.GROW_TOTAL]: '#367C2B',
  [CHART_DATASETS.MAINTAIN_TOTAL]: '#86B07F',
  [CHART_DATASETS.CONTROL_TOTAL]: '#FFDE00',
  [CHART_DATASETS.LIMITED_USE_TOTAL]: '#FFB000',
  [CHART_DATASETS.REDUCE_TOTAL]: '#DA6672',
  [CHART_DATASETS.DONOTUSE_TOTAL]: '#C21020'
});

// Status indicator colors
export const STATUS_COLORS = Object.freeze({
  POSITIVE: '#479339',
  NEGATIVE: '#E01F25'
});

export const PARTIAL_DATA_WARNING =
  'Data may be incomplete — this API partially failed';

export const RENAME_MAP = Object.freeze({
  [CHART_DATASETS.GROW_TOTAL]: 'Grow',
  [CHART_DATASETS.MAINTAIN_TOTAL]: 'Maintain',
  [CHART_DATASETS.CONTROL_TOTAL]: 'Control',
  [CHART_DATASETS.LIMITED_USE_TOTAL]: 'Limited Use',
  [CHART_DATASETS.REDUCE_TOTAL]: 'Reduce',
  [CHART_DATASETS.DONOTUSE_TOTAL]: 'Do not Use'
});

export const NUMERATOR = 'numerator';
export const PERCENTAGE = 'percentage';
export const DENOMINATOR = 'denominator';

export const RENAME_MAP_NEW = Object.freeze({
  [NUMERATOR]: 'Grow + Maintain + Control',
  [PERCENTAGE]: 'Utilization',
  [DENOMINATOR]: 'Total Strategy Spend'
});

export const RENAME_STRATEGY_MAP = Object.freeze({
  [CHART_All_DATASETS.THIS_STRATEGY]: 'This Strategy',
  [CHART_All_DATASETS.OTHER_STRATEGIES]: 'Other John Deere Spend'
});

export const LABEL_LIST_TEXT_FONT_SIZE = 5;

export const LABEL_LIST_MIN_Y_GAP = LABEL_LIST_TEXT_FONT_SIZE * 1.3;

export const BAR_MAX_SIZE = 40;

export const SAM_ROLE_STRATEGY_ADMIN = 'STRATEGY_ADMIN';
export const SRO_ROLE_SBM = 'SRO_SBM';
export const SRO_ROLE_COMM_MGR = 'SRO_COMM_MGR';

// Constants for API Errors
export const SDIS_API_ERR_MSG = 'Unable to retrieve SDIs';
export const AE_RATING_API_ERR_MSG = 'Unable to retrieve AE Rating';
export const RISK_RATING_API_ERR_MSG = 'Unable to retrieve Risk Rating';
export const SRO_SBM_API_ERR_MSG = 'Unable to retrieve SRO SBM Info';
export const SEP_PLANS_API_ERR_MSG = 'Unable to retrieve SEP Plans';
export const AE_RATING_PROP_NAME = 'aeRating';
export const RISK_RATING_PROP_NAME = 'riskRating';
export const SDIS_PROP_NAME = 'sdis';
export const SRO_SBM_PROP_NAME = 'sroSbmName';
export const SRO_SBM_USER_ID_PROP_NAME = 'sroSbmUserId';

//Constant for Scope
export const SCOPE_LEVEL_GLOBAL_PRODUCTION = 'Global Production';
export const SCOPE_LEVEL_GLOBAL_AFTERMARKET = 'Global Aftermarket';
export const SCOPE_LEVEL_UNITORUNITGROUP = 'Unit or Unit Group';

//Strategy Status
export const STRATEGY_STATUS_DRAFT = 'Draft';
export const STRATEGY_STATUS_ACTIVE = 'Active';
export const STRATEGY_STATUS_DELETED = 'Deleted';

//Supplier Status
export const SUPPLIER_STATUS = 'Supplier Status';
export const SUPPLIER_STATUS_GROW = 'Grow';
export const SUPPLIER_STATUS_MAINTAIN = 'Maintain';
export const SUPPLIER_STATUS_CONTROL = 'Control';
export const SUPPLIER_STATUS_REDUCE = 'Reduce';
export const SUPPLIER_STATUS_DONOTUSE = 'Do Not Use';
export const SUPPLIER_STATUS_LIMITED_USE = 'Limited Use';

// Strategic vs Non-Strategic
export const STRATEGIC = 'Strategic';
export const NON_STRATEGIC = 'Non-Strategic';

//Supplier Status Tooltip
export const STRATEGIC_TOOLTIP = [
  ['Strategic', 'Long-term sourcing partner for strategy MGC & scope'],
  ['Grow', 'Actively target business growth with a supplier'],
  ['Maintain', 'Maintain supplier current business'],
  ['Control', 'Actively control supplier business direction']
];
export const NON_STRATEGIC_TOOLTIP = [
  [
    'Non-Strategic',
    'Not a long-term sourcing partner for strategy MGC & scope'
  ],
  ['Limited Use', 'Service only, spot buy, prototype'],
  [
    'Reduce',
    'Target business opportunities to resource to suppliers in strategy'
  ],
  [
    'Do Not Use',
    'Suppliers should not be used for the units in this strategy. Used primarily for regional management of a supplier with multiple locations'
  ]
];

//Strategy Overview Tooltips
export const STRATEGY_OWNER_TOOLTIP =
  'Strategy Owners come from SBMs for Direct or Aftermarket suppliers in SRO and are available the day after SRO setup';
export const STRATEGY_APPROVER_TOOLTIP =
  'Strategy Approvers come from Commodity Managers for Direct or Aftermarket commodities in SRO and are available the day after SRO setup';

//SDForm
export const DIRECT_STRATEGY_MANAGEMENT = 'dmsm';

//Strategy Update
export const STRATEGY_OWNER = 'Owner';
export const STRATEGY_APPROVER = 'Approver';
export const STAKEHOLDER_TYPE_STRATEGY_OWNER = 'strategy_owner';
export const STAKEHOLDER_TYPE_STRATEGY_APPROVER = 'strategy_approver';
export const DEFAULT_STAKEHOLDER_TYPES = [
  STAKEHOLDER_TYPE_STRATEGY_OWNER,
  STAKEHOLDER_TYPE_STRATEGY_APPROVER
];

// Admin Features
export const STRATEGY_UPDATE = 'Strategy Update';
export const TEMPLATES = 'Templates';
export const ADD_TEMPLATES = 'Add Templates';
export const CLEAR = 'Clear';
export const ENTER_INPUT = 'Enter input here...';
export const DESCRIPTION = 'Description';
export const TAG_TO_PHASE = 'Tag to Phase';

// PHASES
export const BEGINNING_PHASE = 1;
export const STARTING_PHASE_FOR_ACTIVE_STATUS = 4;
export const SOURCING_PROCESS = 'Sourcing Process';
export const PHASE_NAME_VAL_PAIRS = [
  { name: SOURCING_PROCESS, value: 'sourcingProcess' },
  { name: 'Phase 1', value: 'phase1' },
  { name: 'Phase 2', value: 'phase2' },
  { name: 'Phase 3', value: 'phase3' },
  { name: 'Phase 4', value: 'phase4' },
  { name: 'Phase 5', value: 'phase5' }
];
export const PHASE_NAME_VALUE_MAP = {
  'Phase 1': 'phase1',
  'Phase 2': 'phase2',
  'Phase 3': 'phase3',
  'Phase 4': 'phase4',
  'Phase 5': 'phase5',
  [SOURCING_PROCESS]: 'sourcingProcess'
};
export const LIST_PHASES = PHASE_NAME_VAL_PAIRS.map((phase) => phase.name);
export const PHASES_LABEL_MAP = {
  1: 'Define Business Scope',
  2: 'Develop Business Solution',
  3: 'Select & Negotiate Suppliers',
  4: 'Implement Strategy',
  5: 'Manage Strategy'
};
export const AVAILABLE_TEMPLATES = 'Available Templates';
export const STRATEGY_STATUS_CANCELED = 'Canceled';
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const ADMIN_FEATURES = 'Admin Features';
export const STRATEGY_PHASE_DATES = 'Strategy Phase Dates';
export const PHASE_DATES = 'Maintain Phases';
export const PHASE_UPDATE_FAILURE = 'Failed to update the phase';
export const PHASE_DATES_UPDATE_FAILURE = 'Failed to update the phase dates';
export const SAVE_SUCCESSFUL = 'Save successful';
export const PHASES = 'Phases';
export const ATTACHMENTS_TITLE = 'Attachments';
export const ATTACHMENT = 'attachment';
export const LINKS_TITLE = 'Relevant Link';
export const COMMENTS_TITLE = 'Comment';
export const SEP_PLANS = 'SEP Plans';

export const SMALL_BUSINESS_FORM = 'Small Business Form';
export const SOURCING_EXECUTION_PLAN = 'Sourcing Execution Plan';
export const MATERIAL_GROUP_CODE = 'Material Group Code';
export const SUPPLIER_PROFILE = 'Supplier Profile';
export const TOTAL_COST_SOLUTION = 'Total Cost Solution';
export const ALL_OTHER_JDSN_APPLICATIONS = 'All other JDSN applications';
export const TCS = 'TCS';
export const SEP = 'SEP';
export const MGC = 'MGC';
export const SBF = 'SBF';
export const NO_SBF = 'No SBF Created';
export const CREATE_SBF = 'Create Small Business Form';
export const INCOMPLETE_SBF = 'Incomplete SBF';
export const SBF_US_MESSAGE =
  'For strategies that include US units, this form documents if Small Businesses were considered as part of your sourcing strategy.';
export const LABELS = Object.freeze({
  COMPLETE_SETUP: 'Complete Set Up',
  SAVE_DRAFT: 'Save Draft',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  REVIEW_STRATEGY: 'Review Strategy'
});

export const SEP_PLAN_TAB_LABELS = Object.freeze({
  NO_PLANS: 'No plans have been created for this strategy yet.',
  PLAN_ID: 'Plan ID',
  PLAN_STATUS: 'Plan Status',
  PLAN_DUE_DATE: 'Plan Due Date',
  SOP_DATE: 'SOP Date',
  UNIT: 'Unit',
  SEP_PROGRAM: 'SEP Program',
  SCI_BUYER: 'SCI Buyer',
  VIEW_OR_EDIT_PLAN_MSG: 'View or Edit Plan in SEP',
  VIEW_PROGRAM_MSG: 'View Program in SEP',
  PROGRAM_STATUS: 'Program Status',
  PROGRAM_PHASE: 'Program Phase',
  SEP_SPEND_GRAPH_TITLE: 'SEP Aggregated PDP Spend by Supplier Status',
  SEP_SPEND_GRAPH_TITLE_TOOLTIP:
    "Spend adjustments are calculated from Current Rep Machine and PDP Rep Machine SAP MBOMs and volumes entered on SEP Program pages by SCI Leads.  Current Rep Machine parts are subtracted from the Forecast spend and PDP Rep Machine parts are added to the Forecast spend starting in the program's production year and beyond. This includes PDP spend changes for SAP units on PAG, PA2 and PAA only.",
  NO_SPEND_MESSAGE: 'No spend for this strategy',
  SEP_SPEND_ERROR_MESSAGE: 'Failed to fetch SEP spend data.',
  SEP_SPEND_TABLE_TITLE: 'SEP Aggregated PDP Spend Table',
  TOTAL_SPEND: 'Total Spend',
  TOTAL_ROW_ID: 'total',
  SUPPLIER_STATUS_ROW_ID: 'supplierStatus'
});

export const PLAN_STATUS = Object.freeze({
  SCI_EDIT: 'SCI Edit',
  SBM_REVIEW: 'SBM Review',
  REVIEW_COMPLETE: 'Review Complete',
  NOT_AVAILABLE: 'n/a'
});

export const SUPPLIER_SEARCH_FILTER_TOOLTIP =
  'Returns Strategic and Prospective suppliers, does not include Non Strategic suppliers.';

export const SELECTION_MODE = Object.freeze({
  SINGLE_SUPPLIER: 'single supplier',
  SUPPLIER_GROUP: 'supplier group'
});

export const CI_PROJECTS_LABEL = 'CI Projects (from Forecast Projects)';
export const CI_PROJECTS_TOOLTIP =
  'Spend impact from CI Resourcing Projects sourced from Forecast Projects. Includes project with Status of Proposed, Active, Approved and PCRC of Global Sourcing, Supplier Resourcing, Insourcing and Outsourcing and Project Type of OFP or blank. Spend is based on 52 week forecasted volume for the parts.';
